import React from "react";
import ReactToPrint from "react-to-print";
import { API_AUTH } from "service/common";
class PrintData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      printContent: "",
      link: "",
    };
  }
  componentDidMount() {
    let { link } = this.props;
    API_AUTH.get(link).then((res) => {
      this.setState({ printContent: res.data });
    });
  }
  componentDidUpdate(preState, preProps) {
    let { link } = this.props;
    if (preState.link !== link) {
      this.setState({ link: link });
      API_AUTH.get(link).then((res) => {
        this.setState({ printContent: res.data });
      });
    }
  }
  // printData = () => () => {
  //   let { link } = this.props;
  //   alert(link);
  //   API_AUTH.get(link).then((res) => {
  //     this.setState({ printContent: res.data });
  //   });
  // };
  render() {
    let { printContent } = this.state;
    return (
      <div title="In Danh Sách">
        <ReactToPrint
          trigger={() => (
            <a href={() => false} className="icon-bgnew color-print1">
              <img src="/app-assets/images/logo-print-v2.png" />
            </a>
          )}
          content={() => this.componentRef}
          copyStyles={false}
        />
        <div style={{ display: "none" }}>
          <div ref={(el) => (this.componentRef = el)}>
            <div
              style={{ width: "100%", color: "#000000", padding: "10px" }}
              dangerouslySetInnerHTML={{ __html: printContent }}
            ></div>
          </div>
        </div>
      </div>
    );
  }
}
export default PrintData;
